import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "font-montserrat" }
const _hoisted_2 = { class: "flex items-center gap-3 text-black-lp-300 w-full" }
const _hoisted_3 = { class: "text-10px sm:text-sm font-semibold h-full flex items-center border-l border-gray-lp-2100 pl-3 ml-3" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-800 font-normal px-2" }, "vs", -1)
const _hoisted_5 = {
  class: "w-82 sm:w-max overflow-y-auto overflow-x-hidden flex flex-col sm:flex-row font-montserrat border border-gray-lp-2100 bg-white rounded-xl divide-x divide-gray-lp-2100",
  style: {"max-height":"calc(100vh / var(--viewport-scale) * 0.75)"}
}
const _hoisted_6 = { class: "border-b sm:border-b-0 border-gray-lp-2100 px-4 py-3" }
const _hoisted_7 = { class: "gap-3 flex flex-wrap items-center justify-center sm:flex-col text-sm font-medium" }
const _hoisted_8 = { class: "rounded-r-lg" }
const _hoisted_9 = { class: "grid grid-cols-1 sm:grid-cols-2 divide-y sm:divide-x divide-gray-lp-2100 w-max" }
const _hoisted_10 = { class: "flex items-center justify-between" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-xs text-gray-500" }
const _hoisted_13 = { class: "text-base font-semibold" }
const _hoisted_14 = { class: "grid grid-cols-7 gap-2 text-center text-sm font-medium text-gray-500" }
const _hoisted_15 = { class: "grid grid-cols-7 gap-y-2 relative" }
const _hoisted_16 = { class: "border-t py-3 px-4 grid grid-cols-1 sm:grid-cols-2 gap-x-8" }
const _hoisted_17 = { class: "flex flex-col gap-y-1 items-center" }
const _hoisted_18 = { class: "flex items-center w-full" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "px-2" }, "-", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "flex-1 text-center min-w-0 text-xs font-semibold text-black-lp-100" }, " vs ", -1)
const _hoisted_21 = { class: "flex items-center w-full" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "px-2" }, "-", -1)
const _hoisted_23 = { class: "flex items-center gap-3 pt-4 sm:pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        class: "flex items-center px-3 h-9 border border-gray-lp-2100 rounded-md text-sm bg-white w-full",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openOverlayPanel && _ctx.openOverlayPanel(...args)))
      }, [
        _createVNode(_component_Icons, {
          name: "calendar",
          class: "w-5 text-gray-lp-600",
          fill: ""
        }),
        _createVNode("div", _hoisted_3, [
          _createVNode("span", {
            class: {
              'text-gray-lp-600 font-normal': !_ctx.formatRange(
                _ctx.modelValue.main.start,
                _ctx.modelValue.main.end
              )
            }
          }, _toDisplayString(_ctx.formatRange(_ctx.modelValue.main.start, _ctx.modelValue.main.end) ||
                _ctx.$t("dashboard.dateRangeCompare.selectDatePeriod")), 3),
          _hoisted_4,
          _createVNode("span", {
            class: {
              'text-gray-lp-600 font-normal': !_ctx.formatRange(
                _ctx.modelValue.compare.start,
                _ctx.modelValue.compare.end
              )
            }
          }, _toDisplayString(_ctx.formatRange(_ctx.modelValue.compare.start, _ctx.modelValue.compare.end) ||
                _ctx.$t("dashboard.dateRangeCompare.selectDatePeriod")), 3)
        ])
      ])
    ]),
    _createVNode(_component_OverlayPanel, {
      id: "date-range-compare",
      ref: "opDateRangeCompare",
      appendTo: "body",
      class: "w-auto"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.presets, (p) => {
                return (_openBlock(), _createBlock("button", {
                  key: p.label,
                  onClick: ($event: any) => (_ctx.applyPreset(p.days)),
                  class: [
                'text-center sm:text-left py-2.5 pl-3 pr-3 sm:pl-3 sm:pr-10 rounded-lg border w-max sm:w-full whitespace-nowrap',
                _ctx.selectedPreset === p.days
                  ? 'bg-gray-100 border-gray-300 font-semibold'
                  : 'border-gray-200 text-gray-600'
              ]
                }, _toDisplayString(p.label), 11, ["onClick"]))
              }), 128))
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              (_openBlock(), _createBlock(_Fragment, null, _renderList(['main', 'compare'], (side) => {
                return _createVNode("div", {
                  key: side,
                  class: "px-6 py-5 flex flex-col gap-y-3 w-max"
                }, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("button", {
                      onClick: ($event: any) => (_ctx.prevMonth(side))
                    }, [
                      _createVNode(_component_Icons, {
                        name: "chevron-left",
                        class: "w-5"
                      })
                    ], 8, ["onClick"]),
                    _createVNode("div", _hoisted_11, [
                      _createVNode("div", _hoisted_12, _toDisplayString(side === "main"
                          ? _ctx.$t("dashboard.dateRangeCompare.mainPeriod")
                          : _ctx.$t("dashboard.dateRangeCompare.comparePeriod")), 1),
                      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.monthYearLabel(_ctx.panel[side])), 1)
                    ]),
                    _createVNode("button", {
                      onClick: ($event: any) => (_ctx.nextMonth(side))
                    }, [
                      _createVNode(_component_Icons, {
                        name: "chevron-left",
                        class: "w-5",
                        style: {"transform":"rotate(180deg)"}
                      })
                    ], 8, ["onClick"])
                  ]),
                  _createVNode("div", _hoisted_14, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.weekdays, (d) => {
                      return (_openBlock(), _createBlock("div", {
                        key: side + '-w-' + d
                      }, _toDisplayString(d), 1))
                    }), 128))
                  ]),
                  _createVNode("div", _hoisted_15, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getCalendarGrid(_ctx.panel[side]), (cell, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: side + '-' + index,
                        class: "text-center rounded-full group bg-opacity-100 bg-white relative cursor-pointer w-10 h-10",
                        onClick: ($event: any) => (_ctx.onCellClick(side as _ctx.Side, cell)),
                        onMouseenter: ($event: any) => (_ctx.onCellEnter(side as _ctx.Side, cell)),
                        onMouseleave: ($event: any) => (_ctx.onCellLeave(side as _ctx.Side))
                      }, [
                        (cell.type === 'current' && _ctx.isInPreviewRange(side as _ctx.Side, cell))
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: ["absolute inset-0 bg-red-lp-50", {
                        'rounded-l-full': _ctx.isPreviewStart(side as _ctx.Side, cell),
                        'rounded-r-full': _ctx.isPreviewEnd(side as _ctx.Side, cell)
                      }]
                            }, null, 2))
                          : _createCommentVNode("", true),
                        _createVNode("div", {
                          class: ["relative z-10 w-full h-full flex items-center justify-center rounded-full text-sm transition-all duration-300", _ctx.cellClass(side as _ctx.Side, cell)]
                        }, _toDisplayString(cell.day), 3)
                      ], 40, ["onClick", "onMouseenter", "onMouseleave"]))
                    }), 128))
                  ])
                ])
              }), 64))
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", {
                    class: ["rounded-md border border-gray-lp-2100 px-3 py-1.5 w-full text-sm", {
                    'text-gray-lp-600': !_ctx.formatDate(_ctx.localDate.main.start)
                  }]
                  }, _toDisplayString(_ctx.formatDate(_ctx.localDate.main.start) || _ctx.$t("dashboard.dateRangeCompare.selectDate")), 3),
                  _hoisted_19,
                  _createVNode("div", {
                    class: ["rounded-md border border-gray-lp-2100 px-3 py-1.5 w-full text-sm", {
                    'text-gray-lp-600': !_ctx.formatDate(_ctx.localDate.main.end)
                  }]
                  }, _toDisplayString(_ctx.formatDate(_ctx.localDate.main.end) || _ctx.$t("dashboard.dateRangeCompare.selectDate")), 3)
                ]),
                _hoisted_20,
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", {
                    class: ["rounded-md border border-gray-lp-2100 px-3 py-1.5 w-full text-sm", {
                    'text-gray-lp-600': !_ctx.formatDate(_ctx.localDate.compare.start)
                  }]
                  }, _toDisplayString(_ctx.formatDate(_ctx.localDate.compare.start) || _ctx.$t("dashboard.dateRangeCompare.selectDate")), 3),
                  _hoisted_22,
                  _createVNode("div", {
                    class: ["rounded-md border border-gray-lp-2100 px-3 py-1.5 w-full text-sm", {
                    'text-gray-lp-600': !_ctx.formatDate(_ctx.localDate.compare.end)
                  }]
                  }, _toDisplayString(_ctx.formatDate(_ctx.localDate.compare.end) || _ctx.$t("dashboard.dateRangeCompare.selectDate")), 3)
                ])
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onReset && _ctx.onReset(...args))),
                  class: "px-4 py-2 border border-red-lp-100 text-red-lp-100 rounded-md w-full font-semibold whitespace-nowrap text-sm"
                }, _toDisplayString(_ctx.$t("dashboard.dateRangeCompare.reset")), 1),
                _createVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args))),
                  class: ["px-4 py-2 text-white rounded-md w-full font-semibold whitespace-nowrap text-sm", {
                  'bg-gray-lp-600 cursor-not-allowed': _ctx.disabledApply,
                  'bg-red-lp-100': !_ctx.disabledApply
                }],
                  disabled: _ctx.disabledApply
                }, _toDisplayString(_ctx.$t("dashboard.dateRangeCompare.apply")), 11, ["disabled"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}